import { createIcon } from '@chakra-ui/icons';

export const ShapeStar = createIcon({
  displayName: 'ShapeStar',
  viewBox: '0 0 12 12 ',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24031)">
        <path
          d="M11.3595 4.07926L8.12177 3.60826L6.67652 0.675012C6.60785 0.556861 6.50936 0.458806 6.39091 0.390649C6.27245 0.322492 6.13819 0.286621 6.00152 0.286621C5.86486 0.286621 5.73059 0.322492 5.61214 0.390649C5.49369 0.458806 5.3952 0.556861 5.32652 0.675012L3.88127 3.60901L0.643524 4.07926C0.504876 4.09915 0.374566 4.15746 0.267355 4.2476C0.160145 4.33773 0.0803174 4.45609 0.0369152 4.58927C-0.00648701 4.72244 -0.0117295 4.8651 0.0217815 5.0011C0.0552926 5.1371 0.126218 5.261 0.226524 5.35876L2.56877 7.64251L2.01602 10.8675C1.99239 11.0054 2.00782 11.1472 2.06056 11.2768C2.1133 11.4065 2.20125 11.5187 2.31447 11.601C2.42769 11.6832 2.56166 11.7321 2.70123 11.7422C2.8408 11.7523 2.98041 11.7231 3.10427 11.658L6.00152 10.1348L8.89727 11.6565C9.02113 11.7216 9.16074 11.7508 9.30032 11.7407C9.43989 11.7306 9.57386 11.6817 9.68708 11.5995C9.8003 11.5172 9.88825 11.405 9.94099 11.2753C9.99373 11.1457 10.0092 11.0039 9.98552 10.866L9.43277 7.64101L11.7765 5.35876C11.8766 5.26107 11.9473 5.13735 11.9808 5.00157C12.0142 4.86579 12.0091 4.72336 11.9659 4.59036C11.9226 4.45737 11.8431 4.3391 11.7362 4.24892C11.6294 4.15874 11.4994 4.10023 11.361 4.08001L11.3595 4.07926Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_916_24031">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
